// extracted by mini-css-extract-plugin
export default {"banner":"ErrorBanner_banner__BezJY","title":"ErrorBanner_title__M-TNe","body":"ErrorBanner_body__ERled"};